export const playersSwap = (playerIn, playerOut ) => `
${playerIn}
<svg class="icon"><use xlink:href="#icon-change"></use></svg>
${playerOut}`;